module.exports = __webpack_public_path__ + "static/media/logo-on-light-reduced-emphasis.0a17eedf.svg";